import { inject } from '@angular/core';
import { 
  ActivatedRouteSnapshot, 
  Router, 
  CanActivate,
  RedirectCommand,
  UrlTree 
} from '@angular/router';
import { lastValueFrom, forkJoin } from 'rxjs';
import { UserService} from '../services/user_service';
import { NoteService } from '../services/note_service';
import { Note } from '../types/note';
export class NoteOwnerGuard implements CanActivate {
    private userService = inject(UserService);
    private noteService = inject(NoteService);
    private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean | RedirectCommand> {
    const noteId = route.paramMap.get('id');
    const notFoundUrl: UrlTree = this.router.parseUrl('/404');
    const homeUrl: UrlTree = this.router.parseUrl('/');

    if (!noteId) {
      return Promise.resolve(new RedirectCommand(notFoundUrl));
    }

    return lastValueFrom(forkJoin([
      this.userService.getProfile(),
      this.noteService.getNoteInfo(noteId),
    ])).then(resp => {
      const loggedUser = resp[0];
      const noteDetails = resp[1] as Note;

      const isLoggedIn = loggedUser && loggedUser.id ? true : false;
      
      if (!noteDetails) {
        return new RedirectCommand(notFoundUrl);
      }

      if (isLoggedIn) {
        return loggedUser.id.toString() === noteDetails.userId.toString();
      } else {
        const path: (string | number)[] = noteDetails.shortURLPath ?
          ['/n', noteDetails.shortURLPath] : 
          ['/notes', noteDetails.id, noteDetails.indexedName || noteDetails.name || noteDetails.id];

        const redirectUrl = this.router.createUrlTree(path);
        return new RedirectCommand(redirectUrl);
      }
    }, () => {
      return new RedirectCommand(homeUrl);
    });
  }
}
